// extracted by mini-css-extract-plugin
module.exports = {"chatBtn":"chatBtn___2hniq","disable":"disable___1Y-9l","on":"on___2L2FY","icon":"icon___3J4nt","has-red-dot":"has-red-dot___3qOXB"};